import React from 'react';
//import { CSSTransition } from 'react-transition-group';
import CSSTransition from 'react-transition-group/CSSTransition';

import { connect } from "react-redux";
//import moment from 'moment';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import de from 'date-fns/locale/de'
import it from 'date-fns/locale/it'
import enUS from 'date-fns/locale/en-US'
//import queryString from "query-string";
import { EncodeUrl } from "../../utils/urls.js";
import { getCars, saveSelectedCar } from "../../stores/carsActions.js";
import { Routing } from "../shared/routing.js";
import { Localize } from "../shared/localize.js";
import { parseUrl, joinUrl } from "./wheel-urls.js";

import { debounce } from "lodash";
import { doSomething } from "../../stores/ajaxActions.js";

const mapStateToProps = state => {
  return {
    cars: state.cars,
    selectedCar: state.cars.selectedCar,
    isProcessing: (state.isProcessing || {}).mostRecentStatus || false
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCars: (data) => dispatch(getCars(data)),
    saveSelectedCar: (data) => dispatch(saveSelectedCar(data)),
    doSomething: (url, payload, method) => dispatch(doSomething(url, payload, method))
  };
};

class ConnectedWheelSearchByCar extends React.Component {
  constructor(props) {
    super(props)

    this.typeSelectRef = React.createRef();
    this.chassisSelectRef = React.createRef();
    
    var parsedUrl = parseUrl();

    //this.props.cars.selectedCar is coming from localStorage, is the last selected car in this browser
    //url may contain a different car
    //we must check if it's the same or not
    //if it's not, here on component initialization we need to give url precedence
    var refreshStore = false;

    // alternativa

    var selectedCar = null;

    // se non abbiamo i dati di ricerca nell'url

    if ((parsedUrl == null) || (parsedUrl.maker || "") == "") {

      // cerchiamo di recuperare i dati dell'ultima ricerca dal redux
      
      selectedCar = (this.props.cars && this.props.cars.selectedCar) ? this.props.cars.selectedCar : {};

      // EVITIAMO DI RICALCOLARE I DATI SOTTO STANTI LA PRIMA VOLTA

      // dobbiamo ricalcolare così anche i diametri e i promoted

      // refreshStore = true;
    }
    else {

      // recuperiamo la selezione dall'url

      selectedCar = {
        maker: parsedUrl.maker,
        model: parsedUrl.model,
        year: parsedUrl.year, 
        chassis: parsedUrl.chassis != parsedUrl.model ? parsedUrl.chassis : "",
        chassisIsSelected: (parsedUrl.chassis || "") != "",
        type: parsedUrl.type,
        typeIsSelected: (parsedUrl.type || "") != ""
      };

      // salviamo la ricerca nel redux

      this.props.saveSelectedCar(
        this.props.cars.selectedCarProperties.reduce(
          (obj, a) => { obj[a] = selectedCar[a]; return obj; }
          , {}
        )
      );

/*
      // se nel makerModelYear non è presente la selezione forziamo la ricarica dei dati

      if ((parsedUrl.maker || "") != "") {
        var models = this.props.cars.makerModelYear.find((c) => c.ManufacturerName.toLowerCase() == parsedUrl.maker.toLowerCase())

        if (models != null) {
          if ((parsedUrl.model || "") != "") {
            var filteredModels = models.Models.filter((v) => { return v.ModelName.toLowerCase() == parsedUrl.model.toLowerCase(); });

            if (filteredModels != null) {

              // se abbiamo il filtro per chassis

              if ((parsedUrl.chassis || "") != "") {
                var chassis = parsedUrl.chassis.toLowerCase() != parsedUrl.model.toLowerCase() ? parsedUrl.chassis.toLowerCase() : "";

                var model = filteredModels.find((f) => { return f.Chassis.toLowerCase() == chassis });

                if (model != null) {
                  if ((parsedUrl.year || "") != "") {
                    if (!model.years.some((b) => { return b.year == parsedUrl.year; })) {
                      refreshStore = true;
                    }
                  }
                }
                else {
                  refreshStore = true;
                }
              }
              else if ((parsedUrl.year || "") != "") {
                if (!filteredModels.some((a) => { return a.years.some((b) => { return b == parsedUrl.year; }) })) {
                  refreshStore = true;
                }
              }
            }
            else {
              refreshStore = true;
            }
          }
        }
        else {
          refreshStore = true;
        }
      }
*/
    }
    
    this.state = Object.assign({}, {
      maker: "",
      model: "",
      year: "",
      chassis: "",
      chassisIsSelected: false,
      type: "",
      typeIsSelected: false,
      ktype: "",
      tyreFit: "",
      rootPathSegment: parsedUrl ? parsedUrl.root : null
    }, selectedCar);

    this.state = { ...this.state, requiredValues: this.crunchDataToRender(this.state) }

    if (refreshStore) {
      this.refreshStore(false);
    }
    //else {
    //  this.setUrl();
    //}
  }

  componentDidMount() {
    if (!(this.props.cars && this.props.cars.makerModelYear && this.props.cars.makerModelYear.length > 10)) {
      this.props.getCars();
    }
  }

  componentWillUnmount() {
  }

  handleInputChange = (e) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    var ns = {};
    switch (name) {
      case "maker":
        ns = { ...this.state, [name]: value, model: "", year: "", chassis: "", chassisIsSelected: false, type: "", typeIsSelected: false, ktype: "" };
        break;
      case "model":
        ns = { ...this.state, [name]: value, year: "", chassis: "", chassisIsSelected: false, type: "", typeIsSelected: false, ktype: "" };
        break;
      case "year":
        ns = { ...this.state, [name]: value, chassis: "", chassisIsSelected: false, type: "", typeIsSelected: false, ktype: "" };
        break;
      case "chassis":
        ns = { ...this.state, [name]: (value != this.state.model ? value : "") , chassisIsSelected: ((value || "") != ""), type: "", typeIsSelected: false };
        break;
      case "type":
        ns = { ...this.state, [name]: value, typeIsSelected: ((value || "") != "") };
        break;
      default:
        ns = { ...this.state, [name]: value };
        break;
    }

    this.setState({ ...ns, requiredValues: this.crunchDataToRender(ns) },
      () => {
        var url = this.refreshStore(true);
        //if (url) {
        //  window.history.pushState("", "", url);
        //}
      }
    );
  }

  crunchDataToRender = (ns) => {
    var requiredValues = { maker: true, model: true, year: true };

    if (this.props.cars && this.props.cars.makerModelYear && this.props.cars.makerModelYear.length) {
      if (this.state.maker) {
        var makerModelYear = this.props.cars.makerModelYear.find((v) => { return v.ManufacturerName.toLowerCase() == this.state.maker.toLowerCase() }); // EncodeUrl(v.ManufacturerName).toLowerCase() == this.state.maker.toLowerCase() });
        if (makerModelYear) {
          var Models = [...(new Set(makerModelYear.Models.map((w) => w.ModelName)))];
        }
      }

      if (this.state.model && this.state.maker) {
        var makerModelYear = this.props.cars.makerModelYear.find((v) => { return v.ManufacturerName.toLowerCase() == this.state.maker.toLowerCase() }); // EncodeUrl(v.ManufacturerName).toLowerCase() == this.state.maker.toLowerCase() });
        if (makerModelYear) {
          var Allyears = makerModelYear
            .Models
            .filter((v) => { return v.ModelName == this.state.model }) // EncodeUrl(v.ModelName) == this.state.model })
            .map((m) => m.years)
            .reduce((a, v) => a.concat(v), []);
          Allyears = [...(new Set(Allyears.map((y) => 1 * y.year)))];
          Allyears.sort((a, b) => b - a);
        }
      }

      switch (this.props.searchType) {
        case "standard":
          if (this.state.model && this.state.maker && this.state.year) {
            var makerModelYear = this.props.cars.makerModelYear.find((v) => { return v.ManufacturerName.toLowerCase() == (this.state.maker || "").toLowerCase() }); // return EncodeUrl(v.ManufacturerName).toLowerCase() == this.state.maker.toLowerCase() });
            var Models = makerModelYear.Models.filter((v) => { return v.ModelName.toLowerCase() == (this.state.model || "").toLowerCase() && v.years.some((y) => y.year == this.state.year) }); // EncodeUrl(v.ModelName).toLowerCase() == this.state.model.toLowerCase() && v.years.some((y) => y.year == this.state.year) });
            var AllChassis = [...(new Set(Models.map((c) => c.Chassis ? c.Chassis : "")))];

            //AllChassis = AllChassis.filter((c) => !!c);
            if (AllChassis && AllChassis.length > 1) {
              requiredValues = { ...requiredValues, chassis: true };
            } else {
              requiredValues = { ...requiredValues, chassis: false };
            }
            //temptative
            if (this.props.cars.carDetails) {
              var AllTypes = this.props.cars.carDetails
                .filter((v) => v.ExtChassis.toLowerCase() == (this.state.chassis || "").toLowerCase()) // DecodeUrl(this.state.chassis, true).toLowerCase())
                .map((v) => { return { ExtModelType: v.ExtModelType, ConstructionFrom: v.ConstructionFrom, ConstructionTo: v.ConstructionTo } })
                .reduce((av, cv) => {
                  return av.some((v) => v && v.ExtModelType == cv.ExtModelType) ? av : av.push(cv) ? av : av;
                }, []);
              if (AllTypes && AllTypes.length > 1) {
                requiredValues = { ...requiredValues, type: true };
              } else {
                requiredValues = { ...requiredValues, type: false };
              }
            }
            //temptative
          }
          break;
        default:
          break;
      }
    }

    return requiredValues;
  }

  setUrl = (reload) => {
    var parsedUrl = parseUrl();

    parsedUrl.maker = this.state.maker;
    parsedUrl.model = this.state.model;
    parsedUrl.year = this.state.year;
    parsedUrl.chassis = this.state.chassisIsSelected ? this.state.chassis || this.state.model : null;
    parsedUrl.type = this.state.typeIsSelected ? this.state.type : null;

    var url = joinUrl(parsedUrl);

    if (!(reload || false)) {
      window.history.pushState("", "", url);
    }
    else {
      window.location.href = url;
    }

    return url;
  }

  handleSearch = (e, searchButtonIsDisabled) => {
    if (searchButtonIsDisabled) {
      //console.log("searchButtonIsDisabled", searchButtonIsDisabled);
      Object.keys(this.state.requiredValues).forEach((k) => {
        if (this.state.requiredValues[k] && !this.state[k] && !(k == "chassis" && this.state.chassisIsSelected) && !(k == "type" && this.state.typeIsSelected)) {
          switch (k) {
            case "type":
              window.setTimeout(() => {
                this.typeSelectRef.current.style.animation = "0.5s jello ease";
                window.setTimeout(() => {
                  this.typeSelectRef.current.style.animation = "none";
                }, 500);
              }, 0);
              break;
            case "chassis":
              window.setTimeout(() => {
                this.chassisSelectRef.current.style.animation = "0.5s jello ease";
                window.setTimeout(() => {
                  this.chassisSelectRef.current.style.animation = "none";
                }, 500);
              }, 0);
              break;
          }
        }
      });
      return;
    }

    //update browser url
    switch (this.props.searchType) {
      case "standard":

        this.setUrl(true);

        break;
      default:
        if (this.state.model && this.state.maker && this.state.year && this.state.ktype) {
          var ktype = this.props.cars.carDetails.find((v) => v.Ktype == this.state.ktype);
          if (ktype) {
            window.location.href = ("/" + Routing.R("cerchi") + "/" + EncodeUrl(this.state.maker) + "/" + EncodeUrl(this.state.model) + "/" + EncodeUrl(this.state.year) + "?carid=" + ktype.Ktype).toLowerCase();
          }
        }
        break;
    }
  }

  refreshCars = debounce((url, payload, method) => this.props.doSomething(url, payload, method), 2000);

  refreshStore = (doSetState) => {
    var ret = null;

    console.log("refreshStore", this.state);

    this.props.saveSelectedCar(
      this.props.cars.selectedCarProperties.reduce(
        (obj, a) => { obj[a] = this.state[a]; return obj; }
        , {}
      )
    );

    // usare debounde che può cancellare le precedenti richieste ed eseguire subito l'operazione
    // https://lodash.com/docs/4.17.15#debounce

    var parsedUrl = parseUrl();

    // richiamiamo l'ajax solo se siamo sulla pagina di ricerca oppure se abbiamo maker / model /year e dobbiamo recuperare i dati relativa agli chassis e type

    if (this.props.isSearchPage || (this.state.maker && this.state.model && this.state.year)) {
      this.refreshCars("/ajax/cars/maker-model-year-ext", {
        root: EncodeUrl(parsedUrl.root),
        maker: this.state.maker,
        model: this.state.model,
        year: this.state.year,
        chassis: this.state.chassisIsSelected ? this.state.chassis || this.state.model : null,
        type: this.state.typeIsSelected ? this.state.type : null,
        diameters: EncodeUrl(parsedUrl.diameters),
        extended: this.props.isSearchPage,
        steeloralloy: parsedUrl.steeloralloy
      }, "POST");

      // effettuare una chiamata istantanea nel caso in cui ci servano chassis e type

      if (this.state.maker && this.state.model && this.state.year) {
        this.refreshCars.flush();
      }
    }

    // this.props.getCars({ maker: EncodeUrl(this.state.maker), model: EncodeUrl(this.state.model), year: EncodeUrl(this.state.year) });

    this.state = { ...this.state, requiredValues: this.crunchDataToRender(this.state) }
    //we are checking the type only, not the chassis, because the chassis is not dependant on carDetails
    if (this.state.type) {
      var type = this.props.cars.carDetails
        .find((v) => v.ExtModelType.toLowerCase() == this.state.type.toLowerCase()); // DecodeUrl(this.state.type, true).toLowerCase());
      if (type) {
        //when called from constructor do not setState
        this.state = { ...this.state, type: type.ExtModelType, typeIsSelected: true }; // EncodeUrl(type.ExtModelType, true), typeIsSelected: true };
        this.state = { ...this.state, requiredValues: this.crunchDataToRender(this.state) }
      }
    }

    if (doSetState) {
      //we don't need to use the callback and wait for the state to be actually updated
      //the remaining code below is not affecting rendering, it only change the browser url
      this.setState(this.state);

      //ret = this.setUrl();
      ret = joinUrl(parsedUrl);
    }

    return ret;
  }

  render() {
    var requiredValues = { maker: true, model: true, year: true };

    if (this.props.cars && this.props.cars.makerModelYear) {
      var makers = [];
      makers.push(<option key={"maker-"} value={""}></option>);
      this.props.cars.makerModelYear.forEach((v, i, a) => {
        makers.push(<option key={"maker-" + i} value={v.ManufacturerName || ""}>{v.ManufacturerName}</option>); // EncodeUrl(v.ManufacturerName)}>{v.ManufacturerName}</option>);
      });

      var models = [];
      if (this.state.maker) {
        models.push(<option key={"model-"} value={""}></option>);
        var makerModelYear = this.props.cars.makerModelYear.find((v) => { return v.ManufacturerName.toLowerCase() == this.state.maker.toLowerCase() }); // EncodeUrl(v.ManufacturerName).toLowerCase() == this.state.maker.toLowerCase() });
        if (makerModelYear) { 
          //let's secure casing
          this.state.maker = makerModelYear.ManufacturerName || ""; // EncodeUrl(makerModelYear.ManufacturerName);
          //we set state here, but we care only about the scope of this render method
        }
        //not 100% sure what I am doing with this if
        if (makerModelYear && makerModelYear.Models && makerModelYear.Models.length) {
          var Models = [...(new Set(makerModelYear.Models.map((w) => w.ModelName)))];
          Models.forEach((v, i, a) => {
            models.push(<option key={"model-" + i} value={v || ""}>{Localize.L(v, { ManufacturerName: this.state.maker, Get: "models" })}</option>); // {EncodeUrl(v)}>{v}</option>);
          });
        }
      }

      var years = [];
      if (this.state.model && this.state.maker) {
        years.push(<option key={"year-"} value={""}></option>);
        var makerModelYear = this.props.cars.makerModelYear.find((v) => { return v.ManufacturerName.toLowerCase() == this.state.maker.toLowerCase() }); // EncodeUrl(v.ManufacturerName).toLowerCase() == this.state.maker.toLowerCase() });
        //not 100% sure what I am doing with this if
        if (makerModelYear && makerModelYear.Models && makerModelYear.Models.length) {
          var Models = makerModelYear.Models.filter((v) => { return v.ModelName.toLowerCase() == this.state.model.toLowerCase() }); // EncodeUrl(v.ModelName).toLowerCase() == this.state.model.toLowerCase() });
          if (Models && Models[0]) {
            //let's secure casing
            this.state.model = Models[0].ModelName; // EncodeUrl(Models[0].ModelName);
            //we set state here, but we care only about the scope of this render method
          }
          var Allyears = Models.map((m) => m.years).reduce((a, v) => a.concat(v), []);
          Allyears = [...(new Set(Allyears.map((y) => 1 * y.year)))];
          Allyears.sort((a, b) => b - a);
          Allyears.forEach((v, i, a) => {
            years.push(<option key={"year-" + i} value={v || ""}>{v}</option>); // EncodeUrl(v)}>{v}</option>);
          });
        }
      }

      var chassisSelect = null;
      var typeSelect = null;

      var engineSelect = null;
      switch (this.props.searchType) {
        case "standard":
          var chassis = [];
          if (this.state.model && this.state.maker && this.state.year) {
            chassis.push(<option key={"chassis-"} value={""}></option>);

            var makerModelYear = this.props.cars.makerModelYear.find((v) => { return v.ManufacturerName.toLowerCase() == this.state.maker.toLowerCase() }); // EncodeUrl(v.ManufacturerName).toLowerCase() == this.state.maker.toLowerCase() });
            //not 100% sure what I am doing with this if
            if (makerModelYear && makerModelYear.Models && makerModelYear.Models.length) {
              var Models = makerModelYear.Models.filter((v) => { return v.ModelName == this.state.model && v.years.some((y) => y.year == this.state.year) }); // EncodeUrl(v.ModelName) == this.state.model && v.years.some((y) => y.year == this.state.year) });
              var AllChassis = [...(new Set(Models.map((c) => c.Chassis ? c.Chassis : c.ModelName)))];

              if (this.state.chassis && AllChassis && AllChassis.length > 0) {
                //let's secure casing
                var tmp = AllChassis.find(c => c.toLowerCase() == (this.state.chassis || "").toLowerCase());
                if (tmp && tmp[0]) {
                  this.state.chassis = tmp; // EncodeUrl(tmp, true);
                  //we set state here, but we care only about the scope of this render method
                }
              }

              if (AllChassis && (AllChassis.length > 1)) {
                requiredValues = { ...requiredValues, chassis: true };
                AllChassis.forEach((v, i, a) => {
                  chassis.push(<option key={"chassis-" + i} value={v || ""}>
                    {Localize.L(this.state.model, { ManufacturerName: this.state.maker, Get: "models" })}
                    {(v ? " - " + Localize.L(v, { ManufacturerName: this.state.maker, Get: "chassis" }) : "")}</option>); // EncodeUrl(v, true)}>{DecodeUrl(this.state.model, true)} {(v ? "-" + v : "")}</option>);
                });
                chassisSelect = (
                  <CSSTransition
                    in={true}
                    appear={!this.state.chassis && !this.state.chassisIsSelected}
                    classNames="bounceIn"
                    timeout={10500}
                  >
                    <div className="col-md" key={"chassisSelect"} ref={this.chassisSelectRef}>
                      <label>{Localize.L("Carrozzeria")}</label>
                      <select
                        name="chassis"
                        className="form-control" style={{ fontSize: 14 }}
                        value={this.state.chassisIsSelected ? this.state.chassis || this.state.model : ""}
                        onChange={(e) => this.handleInputChange(e)}>
                        {chassis}
                      </select>
                    </div>
                  </CSSTransition>
                );
              }
              //temptative
              var types = [];
              if (this.props.cars.carDetails) {
                types.push(<option key={"type-"} value={""}></option>);

                var chassis = (this.state.chassis || this.state.model).toLowerCase() != this.state.model.toLowerCase() ? this.state.chassis : "";
                var AllTypes = this.props.cars.carDetails
                  .filter((v) => AllChassis.length == 1 || v.ExtChassis.toLowerCase() == chassis.toLowerCase()) // DecodeUrl(this.state.chassis, true).toLowerCase())
                  .map((v) => { return { ExtModelType: v.ExtModelType, ConstructionFrom: v.ConstructionFrom, ConstructionTo: v.ConstructionTo } })
                  .reduce((av, cv) => {
                    return av.some((v) => v && v.ExtModelType == cv.ExtModelType) ? av : av.push(cv) ? av : av;
                  }, []);
                //console.log("AllTypes",AllTypes);

                if (this.state.type && AllTypes && AllTypes.length > 0) {
                  //let's secure casing
                  var tmp = AllTypes.find(v => v.ExtModelType.toLowerCase() == this.state.type.toLowerCase());
                  if (tmp) {
                    this.state.type = tmp.ExtModelType; // EncodeUrl(tmp.ExtModelType, true);
                    //we set state here, but we care only about the scope of this render method
                  }
                }

                if (AllTypes && AllTypes.length > 1) {
                  requiredValues = { ...requiredValues, type: true };
                  AllTypes.forEach((v, i, a) => {
                    //var fromDate = moment(v.ConstructionFrom).locale(window.navigator.userLanguage || window.navigator.language).format("MMM YYYY");
                    //var toDate = moment(v.ConstructionTo).locale(window.navigator.userLanguage || window.navigator.language).format("MMM YYYY");

                    var fromDate = parseISO(v.ConstructionFrom);
                    var toDate = parseISO(v.ConstructionTo);

                    switch ((window.navigator.userLanguage || window.navigator.language).substring(0, 2)) {
                      case "it":
                        fromDate = format(fromDate, "MMM y", { locale: it });
                        toDate = format(toDate, "MMM y", { locale: it });
                        break;
                      case "de":
                        fromDate = format(fromDate, "MMM y", { locale: de });
                        toDate = format(toDate, "MMM y", { locale: de });
                        break;
                      default:
                        fromDate = format(fromDate, "MMM y", { locale: enUS });
                        toDate = format(toDate, "MMM y", { locale: enUS });
                        break;
                    }

                    fromDate = fromDate.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
                    toDate = toDate.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
                    types.push(<option key={"type-" + i} value={v.ExtModelType || ""}>{v.ExtModelType} (da {fromDate} a {toDate})</option>); // EncodeUrl(v.ExtModelType, true)}>{v.ExtModelType} (da {fromDate} a {toDate})</option>);
                  });
                  typeSelect = (
                    <CSSTransition
                      in={true}
                      appear={!this.state.type && !this.state.typeIsSelected}
                      classNames="bounceIn"
                      timeout={10500}
                    >
                      <div className="col-md" key={"typeSelect"} ref={this.typeSelectRef}>
                        <label>{Localize.L("Type")}</label>
                        <select
                          name="type"
                          className="form-control" style={{ fontSize: 14 }}
                          value={this.state.typeIsSelected ? this.state.type : ""}
                          onChange={(e) => this.handleInputChange(e)}>
                          {types}
                        </select>
                      </div>
                    </CSSTransition>
                  );
                }
              }
            }
            //temptative
          }
          break;
        default:
          engineSelect = (
            <WheelSearchEngines
              cars={this.props.cars}
              selected={this.state}
              handleInputChange={this.handleInputChange}
            />
          );
          break;
      }

      var searchButtonIsDisabled = Object.keys(requiredValues).some(k => requiredValues[k] && !this.state[k] && !(k == "chassis" && this.state.chassisIsSelected) && !(k == "type" && this.state.typeIsSelected));

      // modifichiamo il pulsante presente nel wordpress dei kits

      var el = document.getElementById('config_kit');
      if (el && !searchButtonIsDisabled) {
        var parsedUrl = parseUrl();

        parsedUrl.root = Routing.R("cerchi");
        parsedUrl.maker = this.state.maker;
        parsedUrl.model = this.state.model;
        parsedUrl.year = this.state.year;
        parsedUrl.chassis = this.state.chassisIsSelected ? this.state.chassis || this.state.model : null;
        parsedUrl.type = this.state.typeIsSelected ? this.state.type : null;

        var url = joinUrl(parsedUrl);

        el.onclick = function () { window.location.href = url; };
      }

      var ret = (
        <fieldset disabled={this.props.cars.isLoading}>
          <form id="category_top_form" onSubmit={e => { e.preventDefault(); }}>
            <div className="row please-no-gutters">
              <div className="col-md">
                <label>{Localize.L("Marca")}</label>
                <select name="maker" className="form-control" style={{ fontSize: 14 }}
                  value={this.state.maker || ""}
                  onChange={(e) => this.handleInputChange(e)}>
                  {makers}
                </select>
              </div>
              <div className="col-md">
                <label>{Localize.L("Modello")}</label>
                <select name="model" className="form-control" style={{ fontSize: 14 }}
                  value={this.state.model || ""}
                  onChange={(e) => this.handleInputChange(e)}>
                  {models}
                </select>
              </div>
              <div className="col-md">
                <label>{Localize.L("Anno")}</label>
                <select name="year" className="form-control" style={{ fontSize: 14 }}
                  value={this.state.year || ""}
                  onChange={(e) => this.handleInputChange(e)}>
                  {years}
                </select>
              </div>
              {chassisSelect}
              {typeSelect}
              {engineSelect}
              <div className="col-md">
                <label htmlFor="select_btn">&nbsp;</label>
                <button style={{ background: "#FB910C", width: "100%" }} className={"horizontal-submit btn btn-orange" + (1==2&&searchButtonIsDisabled?" disabled":"")}
                  disabled={searchButtonIsDisabled}
                  onClick={(e) => this.handleSearch(e, searchButtonIsDisabled) }
                >
                  {Localize.L("Cerca")}
                </button>
              </div>
            </div>
          </form>
        </fieldset>
      );
    }

    return ret;
  }
}

class WheelSearchEngines extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {

    var ret = null;
    if (this.props.cars && this.props.cars.makerModelYear) {
      var ktypes = [];
      if (this.props.selected.model && this.props.selected.maker && this.props.selected.year) {
        ktypes.push(<option key={"ktype-"} value={""}></option>);
        this.props.cars.carDetails.forEach((v, i, a) => {
          var impulsionType = v.ImpulsionType;
          switch (impulsionType) {
            case "All-wheel Drive":
            case "All Wheel Drive":
              impulsionType = Localize.L("4x4")
              break;
            case "Front Wheel Drive":
              impulsionType = Localize.L("Traz.Ant.")
              break;
            case "Rear Wheel Drive":
              impulsionType = Localize.L("Traz.Pos.")
              break;
          }
          var constructionType = v.ConstructionType;
          switch (constructionType) {
            case "Box":
            case "Box Body / Estate":
              constructionType = Localize.L("Furgone")
              break;
            case "Closed Off-Road Vehicle":
            case "Open Off-Road Vehicle":
              constructionType = Localize.L("Off-Road")
              break;
            case "Convertible":
              constructionType = Localize.L("Cabriolet")
              break;
            case "Dumptruck":
              constructionType = Localize.L("Camion")
              break;
            case "Estate":
              constructionType = Localize.L("Station wagon")
              break;
            case "Hatchback":
              constructionType = Localize.L("Due volumi")
              break;
            case "MPV":
              constructionType = Localize.L("Monovolume")
              break;
            case "Saloon":
              constructionType = Localize.L("Berlina")
              break;
          }
          var text = (v.FuelType ? v.FuelType.replace("Petrol", Localize.L("Benzina")) + " " : "")
            + v.CarName + " "
            + (v.CylinderCapacityCcm ? v.CylinderCapacityCcm + Localize.L("cc") + " " : "")
            + (v.PowerHpFrom ? "(" + v.PowerHpFrom + Localize.L("cv") + ") " : "")
            + impulsionType + " " + constructionType;
          ktypes.push(<option key={"ktype-" + i} value={v.Ktype || ""}>{text}</option>);
        });
      }

      ret = (
        <div className="col">
          <label>Motorizzazione</label>
          <select name="ktype" style={{ fontSize: 14 }}
            value={this.props.selected.ktype}
            onChange={(e) => this.props.handleInputChange(e)}>
            {ktypes}
          </select>
        </div>
      );
    }

    return ret;
  }
}
const WheelSearchByCar = connect(mapStateToProps, mapDispatchToProps)(ConnectedWheelSearchByCar);

export { WheelSearchByCar }
